import { takeLatest, call, put, select, all } from 'redux-saga/effects';
import { voiceModelActions } from '.';
import toast from "react-hot-toast";
import { Api } from '../../../../store/api';

function* fetchVoicesSaga(action) {
    try {
        console.log("fetchVoiceSaga ", action);
        let voices = []
        if (action.payload?.isSignedIn) {
            voices = yield Api.fetchVoices();
        } 
        const publicVoices = yield Api.fetchPublicVoices();
        
        yield put({type: voiceModelActions.updateVoices.type, payload: {
                voices: voices,
                publicVoices: publicVoices,
            }});
    } catch (e) {
        yield put({type: voiceModelActions.fetchVoicesError.type, payload: e});
    }
}

function* fetchTtsVoicesSaga(action) { 
    try {
        console.log("fetchTtsVoicesSaga ", action);
        let ttsVoices = []
        if (action.payload?.isSignedIn) {
            ttsVoices = yield Api.fetchTtsVoices();
        }
        // TODO: Uncomment this when we have a way to fetch public TTS voices
        // const ttsPublicVoices = yield Api.fetchTtsPublicVoices();

        yield put({type: voiceModelActions.updateTtsVoices.type, payload: {
                ttsVoices: ttsVoices,
                ttsPublicVoices: [],// TODO: use ttsPublicVoices when we have a way to fetch public TTS voices
            }});
    } catch (e) {
        yield put({type: voiceModelActions.fetchTtsVoicesError.type, payload: e});
    }
}

// Voice Models saga
export default function* voiceModelsSaga() {
    // if necessary, start multiple sagas at once with `all`
    yield all([
        takeLatest(voiceModelActions.fetchVoices.type, fetchVoicesSaga),
        takeLatest(voiceModelActions.fetchTtsVoices.type, fetchTtsVoicesSaga)
    ]);
}